export * from './authentication/authentication.component';
export * from './private/private.component';